import {pipelineRoutes} from "../../consts/consts";
import {calculateTotalColumn,formatDateTimeString} from "../../utils";

export class PipelineByStatusModel {
    id;
    LISTED_DATE;
    NAME;
    ADDRESS;
    CITY;
    STATE;
    PRICE;
    GROSS_FEE;
    SPLIT_W_OA;
    STRIVE_FEE;
    STATUS;

    constructor({data, isTotal, status}) {
        if (isTotal) {
            this.id = null;
            this.LISTED_DATE = null;
            this.NAME = 'TOTAL';
            this.ADDRESS = null;
            this.CITY = null;
            this.STATE = null;
            this.PRICE = calculateTotalColumn(data,'PRICE');
            this.GROSS_FEE = calculateTotalColumn(data,'GROSS_FEE');
            this.SPLIT_W_OA = calculateTotalColumn(data,'SPLIT_W_OA');
            this.STRIVE_FEE = calculateTotalColumn(data,'STRIVE_FEE');
            this.STATUS = data.STATUS;
        } else {
            this.id = data.ARCIMEDES_ROW_ID;
            this.LISTED_DATE = data.LISTED_DATE
            this.NAME = data.NAME;
            this.ADDRESS = data.ADDRESS;
            this.CITY = data.CITY;
            this.STATE = data.STATE;
            this.CLOSE_OF_ESCROW = data.CLOSE_OF_ESCROW ? formatDateTimeString(data.CLOSE_OF_ESCROW):'';
            this.STATUS = data.STATUS;
            let listSplit, buySplit, refListSplit, refBuySplit;
            switch(status){
                case pipelineRoutes.active:
                    this.PRICE = data.LIST_PRICE ? data.LIST_PRICE : 0;
                    this.GROSS_FEE = data.ACTIVE_GROSS_FEE ? data.ACTIVE_GROSS_FEE : 0;
                    break;
                case pipelineRoutes.inNegotiation:
                case pipelineRoutes.underContract:
                case pipelineRoutes.totalNegUc:
                    listSplit = parseFloat(data.LISTING_SPLIT_W_OA);
                    buySplit = parseFloat(data.BUYING_SPLIT_W_OA);
                    refListSplit = data.LISTING_SPLIT_W_RA ? parseFloat(data.LISTING_SPLIT_W_RA) : 0;
                    refBuySplit = data.BUYING_SPLIT_W_RA ? parseFloat(data.BUYING_SPLIT_W_RA) : 0;
                    this.SPLIT_W_OA= listSplit + buySplit + refListSplit + refBuySplit;
                    this.PRICE = data.NEGOTIATION_PRICE ? data.NEGOTIATION_PRICE : 0;
                    this.GROSS_FEE = data.NEGOTIATION_GROSS_FEE ? data.NEGOTIATION_GROSS_FEE : 0;
                    this.STRIVE_FEE = this.GROSS_FEE - this.SPLIT_W_OA;
                    break;
                case pipelineRoutes.inNegUcOther:
                    this.SPLIT_W_OA = null;
                    this.STRIVE_FEE = null;
                    this.GROSS_FEE = data.REFERRAL_FEE ? data.REFERRAL_FEE : 0;
                    break;
                case pipelineRoutes.closedYTD:
                    this.PRICE = data.SOLD_PRICE ? data.SOLD_PRICE : 0;
                    listSplit = data.LISTING_CLOSED_SPLIT_W_OA ? parseFloat(data.LISTING_CLOSED_SPLIT_W_OA): 0;
                    buySplit = data.BUYING_CLOSED_SPLIT_W_OA? parseFloat(data.BUYING_CLOSED_SPLIT_W_OA): 0;
                    refListSplit = data.LISTING_CLOSED_SPLIT_W_RA ? parseFloat(data.LISTING_CLOSED_SPLIT_W_RA) : 0;
                    refBuySplit = data.BUYING_CLOSED_SPLIT_W_RA ? parseFloat(data.BUYING_CLOSED_SPLIT_W_RA) : 0;
                    this.SPLIT_W_OA= listSplit + buySplit + refListSplit + refBuySplit;
                    this.GROSS_FEE = data.CLOSED_GROSS_FEE ? data.CLOSED_GROSS_FEE : 0;
                    this.STRIVE_FEE = this.GROSS_FEE - this.SPLIT_W_OA;
                    break;
                case pipelineRoutes.closedYTDOther:
                    this.PRICE = data.SOLD_PRICE ? data.SOLD_PRICE : 0;
                    listSplit = parseFloat(data.LISTING_CLOSED_SPLIT_W_OA);
                    buySplit = parseFloat(data.BUYING_CLOSED_SPLIT_W_OA);
                    refListSplit = data.LISTING_CLOSED_SPLIT_W_RA ? parseFloat(data.LISTING_CLOSED_SPLIT_W_RA) : 0;
                    refBuySplit = data.BUYING_CLOSED_SPLIT_W_RA ? parseFloat(data.BUYING_CLOSED_SPLIT_W_RA) : 0;
                    this.SPLIT_W_OA= listSplit + buySplit + refListSplit + refBuySplit;
                    this.GROSS_FEE = data.REFERRAL_FEE ? data.REFERRAL_FEE : 0;
                    this.STRIVE_FEE = this.GROSS_FEE - this.SPLIT_W_OA;
                    break;
            }
        }
    }
}
